import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon } from 'lucide-react';
interface TrendingPrediction {
  id: number;
  question: string;
  volume: string;
}
interface PredictionSidebarProps {
  trendingPredictions: TrendingPrediction[];
}
export const PredictionSidebar = ({
  trendingPredictions
}: PredictionSidebarProps) => {
  return <aside className="space-y-8" data-id="element-229">
      {/* Trending Predictions */}
      <div data-id="element-230">
        <h3 className="text-lg font-bold mb-4 pb-2 border-b border-gray-200 flex items-center" data-id="element-231">
          <TrendingUpIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-232" />
          Trending Predictions
        </h3>
        <div className="space-y-4" data-id="element-233">
          {trendingPredictions.map((prediction, index) => <div key={prediction.id} className="flex gap-3" data-id="element-234">
              <span className="text-2xl font-bold text-gray-300" data-id="element-235">
                {index + 1}
              </span>
              <div data-id="element-236">
                <h4 className="font-medium text-gray-900 mb-1 hover:text-blue-600" data-id="element-237">
                  <Link to={`/prediction/${prediction.id}`} data-id="element-238">
                    {prediction.question}
                  </Link>
                </h4>
                <span className="text-xs text-blue-600 font-medium" data-id="element-239">
                  Volume: {prediction.volume}
                </span>
              </div>
            </div>)}
        </div>
      </div>
      {/* Create Prediction */}
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100" data-id="element-240">
        <h3 className="text-lg font-bold mb-3" data-id="element-241">Create Your Own Market</h3>
        <p className="text-sm text-gray-600 mb-4" data-id="element-242">
          Have a prediction about future events? Create your own prediction
          market and let others bet on the outcome.
        </p>
        <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md transition-colors" data-id="element-243">
          Create Prediction
        </button>
      </div>
      {/* How it Works */}
      <div className="bg-gray-50 p-6 rounded-lg border border-gray-100" data-id="element-244">
        <h3 className="text-lg font-bold mb-3" data-id="element-245">How Predictions Work</h3>
        <ul className="text-sm text-gray-600 space-y-2" data-id="element-246">
          <li className="flex items-start" data-id="element-247">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-2 mt-0.5" data-id="element-248">
              1
            </span>
            <span data-id="element-249">Choose a prediction market that interests you</span>
          </li>
          <li className="flex items-start" data-id="element-250">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-2 mt-0.5" data-id="element-251">
              2
            </span>
            <span data-id="element-252">Select an outcome and decide how much to bet</span>
          </li>
          <li className="flex items-start" data-id="element-253">
            <span className="bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs mr-2 mt-0.5" data-id="element-254">
              3
            </span>
            <span data-id="element-255">If your prediction is correct, you win!</span>
          </li>
        </ul>
        <Link to="/how-it-works" className="text-blue-600 hover:text-blue-800 text-sm font-medium mt-4 inline-block" data-id="element-256">
          Learn more
        </Link>
      </div>
    </aside>;
};